import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 't4-upload-message',
    templateUrl: './upload-message.component.html',
    styleUrls: ['./upload-message.component.scss'],
    standalone: false
})
export class UploadMessageComponent implements OnInit {
    public headerText = '';
    public lines: string[] = [];

    constructor(
    public dialogRef: MatDialogRef<UploadMessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translate: TranslateService
    ) {
    if (data.cancelonly === undefined) {
      data.cancelonly = false;
    }
    if (data.okonly === undefined) {
      data.okonly = false;
    }
    if (data.isWarning === undefined) {
      data.isWarning = false;
    }
  }

  ngOnInit() {
    if (!this.data.errors || !this.data.message || !this.data.messageAdditional) {
        return;
    }

    this.headerText = this.translate.instant(this.data.message);
    this.lines = this.buildLines(this.data.errors, this.data.messageAdditional);
  }

  private buildLines(items: string[], additionalMessage: string): string[] {
    const maxLines = 5;
    const lines: string[] = [];

    for (let i = 0; i < items.length; i++) {
      if (i >= maxLines) {
        const remaining = String(items.length - i);
        const args = this.data.isWarning ? { remainingWarnings: remaining } : { remainingErrors: remaining };
        lines.push(this.translate.instant(additionalMessage, args));
        break;
      }

      lines.push(this.translate.instant(items[i]));
    }

    return lines;
  }
}
